import React, { useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import FormModalCreateGrupo from '../forms/formModalCreateGrupo';
import ModalBaseSm from '../../modals/modal-base-sm';

const ModalAdminGrupos = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [groups, setGroups] = useState([]);
    const [idEdit, setIdEdit] = useState(-1);

    const [dialogOpen, setDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return groups;
        return groups.filter(item =>
            Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            )
        );
    }, [groups, debouncedTerm]);

    const guardar = () => {
        console.log('Guardar grupo');
    };

    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    const toggleDialog = () => {
        setDialogOpen(o => !o);
        // si luego agregas campos al formulario de grupos, aquí los limpias cuando cierres
        // if (dialogOpen) {
        //     setIdEdit(-1);
        // }
    };

    return (
        <>
            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                    @media (max-width: 575.98px) {
                        .btn-nuevo-grupo {
                            width: 100%;
                        }
                    }
                `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar grupos..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nuevo-grupo"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nuevo Grupo
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th style={{ color: '#ffffff', width: '100%' }}>
                                    Nombre
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((item, i) => (
                                <tr key={i}>
                                    <td style={{ color: '#000' }}>
                                        {item.Nombre || '-'}
                                    </td>
                                    {/* resto de columnas/comportamientos los ajustas cuando tengas claro
                                        qué datos va a manejar el grupo */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <ModalBaseSm
                isOpen={dialogOpen}
                title={
                    idEdit === -1 ? 'Crear Grupo' : 'Editar Grupo'
                }
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateGrupo
                        onSave={guardar}
                    />
                }
            />
        </>
    );
};

export default ModalAdminGrupos;
